module.exports = __webpack_public_path__ + "img/tips1.e283fcaf.png";